import TagBox from "devextreme-react/tag-box";
import { useEffect, useState } from "react";
import { hinhThucNopBomApi } from "../../api/hinhThucNopBom";
import { useCommonContext } from "../../contexts/common";
import { sf_hinhthucnopbom } from "../../models/response/category/sf_hinhthucnopbom";
type ITagboxHinhThucNopBomProps = {
    isReadonly?: boolean,
    value?: number[],
    width?: number,
    onValueChanged: (id: number[], data?: sf_hinhthucnopbom[]) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined",
    dmCoSoId?: number

}
const TagboxHinhThucNopBom = (props: ITagboxHinhThucNopBomProps) => {
    const [hinhThucNopBoms, setHinhThucNopBoms] = useState<sf_hinhthucnopbom[]>([]);
    useEffect(() => {
        handleReloadHinhThucNopBoms();
    }, [])
    const handleReloadHinhThucNopBoms = async () => {
        const res = await hinhThucNopBomApi.selectAll();
        setHinhThucNopBoms(res.data.filter((x:any)=>x.id > 0))
    }
    const { translate } = useCommonContext();
    return (
        <TagBox dataSource={hinhThucNopBoms}
            displayExpr={"name"}
            valueExpr={"id"}
            value={props.value}
            stylingMode={props.stylingMode || "outlined"}
            readOnly={props.isReadonly === true}
            placeholder={translate("Chọn kỳ nộp")}
            width={props.width ?? "100%"}
            height={33}
            className={"default_selectbox " + (props.className ? props.className : "")}
            showClearButton={props.isShowClearButton === true}
            maxDisplayedTags={1}
            showSelectionControls={true}
            onValueChanged={(e) => {
                if (e.event) {
                    if (e.value) {
                        const data = hinhThucNopBoms.filter(x => e.value.includes(x.id))
                        props.onValueChanged(e.value, data)
                    } else {
                        props.onValueChanged([], [])
                    }
                }
            }} />
    );
}
export default TagboxHinhThucNopBom

